import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  InputLabel,
  Select,
  Tooltip,
} from "@mui/material";
import { useSnackbar } from "notistack";
import CameraAltIcon from "@mui/icons-material/CameraAltOutlined";
import PersonIcon from "@mui/icons-material/PersonOutline";
import logo from "../../../src/assets/images/logoman.png";
import { baseUri, s3baseUri } from "../../config/config";
import CircularProgress from "@mui/material/CircularProgress";
// import { useAdminContext } from "../../hooks/useContext/AdminContext";
import { useIds } from "../../hook/AdminContext";
import { useLocation } from "react-router-dom";
import { show_proper_words } from "../../utils/Constant";
import GeneralMuiModal from "../../components/modal/GeneralMuiModal";
import PageLoading from "../../components/loader/PageLoading";
import FormControl from "@mui/material/FormControl";

import {
  candidate_api_detail_fetch,
  candidate_edit_profile_api,
  client_detail_api,
  client_profile_edit_api,
} from "../../DAL/partner/partners";
import TextEditor from "../../components/editors/ReactEditor";
import CropPopUp from "../../components/userslistToolbars/CCropPopUp";
import { CleaningServices } from "@mui/icons-material";

const EditProfile = () => {
  const { enqueueSnackbar } = useSnackbar();
  const fileInputRef = useRef(null);
  // const { setUserInfo } = useAdminContext();
  const { setBreadCrumb, fetchAdminDetail, userInfo } = useIds();
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const [imageStatus, setImageStatus] = useState(false);
  // const [file, setProfileImage] = React.useState({});
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [imageRef, setImageRef] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const [file, setFile] = useState(null);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
    ]);
  }, []);

  const INITIAL_VALUES = {
    first_name: "",
    email: "",
    anchorEl: null,
    avatar: "",
    dialogOpen: false,
    loading: false,
    last_name: "",
    post_code: "",
    contact_number: "",
    status: true,
    company_name: "",
    sectorChoose: "",
    contact_name: "",
    twitter_link: "",
    youtube: "",
    linkedIn_link: "",
    facebook_link: "",
    instagram_link: "",
    location: "",
    website: "",
    street_address: "",
    state: "",
    city: "",
    country: "",
    about: "",
    image: "",
  };

  const [inputs, setInputs] = useState(INITIAL_VALUES);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [previews, setPreviews] = useState("");
  const [oldProfile, setOldProfile] = useState();
  const { setProfileNewImage, setUserInfo } = useIds();
  const [openPopUp, setOpenPopUp] = useState(false);

  const [detailData, setDetailData] = useState(null);
  const [crop, setCrop] = useState({
    unit: "%",
    width: 95,
    height: 95,
    x: 2.5,
    y: 2.5,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((old) => ({ ...old, [name]: value }));
  };
  const handleSaveFullImage = () => {
    if (file) {
      // Convert base64 to file object
      fetch(file)
        .then((res) => res.blob())
        .then((blob) => {
          const fullImageFile = new File([blob], "full-image.jpeg", {
            type: "image/jpeg",
          });

          // Set the full image in inputs
          setInputs((prev) => ({ ...prev, image: fullImageFile }));

          // Set preview (use the original file as preview)
          setCroppedImage(file);

          // Close modal
          setCropModalOpen(false);
        });
    }
  };

  const handleMenuOpen = (event) => {
    setInputs((old) => ({ ...old, anchorEl: event.currentTarget }));
  };
  const makeClientCrop = async (crop) => {
    if (imageRef && crop.width && crop.height) {
      const result = await getCroppedImg(imageRef, crop);

      // Set preview URL for display
      setCroppedImage(result.previewUrl);

      // Set the actual file object in inputs for form submission
      setInputs((prev) => ({ ...prev, image: result.file }));

      console.log("Cropped file object:", result.file);
      console.log("Preview URL:", result.previewUrl);
    }
  };

  const handleCropImage = async () => {
    if (!imageRef) {
      alert("Image not loaded");
      return;
    }

    let finalCrop = crop;

    // Convert percentage crop to pixel crop if needed
    if (crop.unit === "%") {
      finalCrop = {
        unit: "px",
        x: (crop.x / 100) * imageRef.width,
        y: (crop.y / 100) * imageRef.height,
        width: (crop.width / 100) * imageRef.width,
        height: (crop.height / 100) * imageRef.height,
      };
    }

    const result = await getCroppedImg(imageRef, finalCrop);
    setCroppedImage(result.previewUrl); // Preview
    setInputs((prev) => ({ ...prev, image: result.file })); // Save for API
    setCropModalOpen(false);
  };
  const getCroppedImg = (image, crop) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }

        // Create file object for form submission
        const croppedFile = new File([blob], "cropped.jpeg", {
          type: "image/jpeg",
        });

        // Create preview URL
        const previewUrl = window.URL.createObjectURL(blob);

        resolve({ file: croppedFile, previewUrl });
      }, "image/jpeg");
    });
  };
  const onImageLoaded = (e) => {
    console.log("Image loaded for cropping:", e.target);
    setImageRef(e.target); // e.target is the actual img element
  };
  const onCropComplete = async (crop) => {
    await makeClientCrop(crop);
  };
  const fileChangedHandler = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Handle SVG files differently
    if (file.type === "image/svg+xml") {
      const reader = new FileReader();
      reader.onload = () => {
        // Directly set the SVG as preview and file
        setCroppedImage(reader.result);
        setInputs((prev) => ({ ...prev, image: file }));
      };
      reader.readAsDataURL(file);
      return; // Skip the cropping modal for SVG
    }

    // Original handling for other image types
    const reader = new FileReader();
    reader.onload = () => {
      setFile(reader.result);
      setCropModalOpen(true);
    };
    reader.readAsDataURL(file);

    setCrop({
      unit: "%",
      width: 95,
      height: 95,
      x: 2.5,
      y: 2.5,
    });

    setCroppedImage(null);
    setInputs((prev) => ({ ...prev, image: null }));
    e.target.value = "";
  };

  const handleMenuClose = () => {
    setInputs((old) => ({ ...old, anchorEl: null }));
  };

  const handleUpdateImage = () => {
    fileInputRef.current.click();
    handleMenuClose();
  };
  const handleModalClose = () => {
    setCropModalOpen(false);
    setFile(null);
    setInputs((old) => ({
      ...old,
      image: s3baseUri + userInfo?.profile_image,
    }));
    setCrop({
      unit: "%",
      width: 95,
      height: 95,
      x: 2.5,
      y: 2.5,
    });
  };

  const handleUpload = (event) => {
    setImageStatus(true);
    setFile(event.target.files[0]);
    const preview = URL.createObjectURL(event.target.files[0]);
    setPreviews(preview);
  };

  const handleViewProfile = () => {
    setInputs((old) => ({ ...old, dialogOpen: true }));
    handleMenuClose();
  };

  const handleDialogClose = () => {
    setInputs((old) => ({ ...old, dialogOpen: false }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validateUrl = (url) => {
      if (url && !/^https?:\/\//i.test(url)) {
        return false; // Invalid URL
      }
      return true; // Valid URL
    };
    const invalidUrls = [];
    if (inputs.facebook_link && !validateUrl(inputs.facebook_link))
      invalidUrls.push("Facebook");
    if (inputs.instagram_link && !validateUrl(inputs.instagram_link))
      invalidUrls.push("Instagram");
    if (inputs.linkedIn_link && !validateUrl(inputs.linkedIn_link))
      invalidUrls.push("LinkedIn");
    if (inputs.website && !validateUrl(inputs.website))
      invalidUrls.push("Website");
    if (inputs.youtube && !validateUrl(inputs.youtube))
      invalidUrls.push("YouTube");
    if (inputs.twitter_link && !validateUrl(inputs.twitter_link))
      invalidUrls.push("Twitter");
    if (invalidUrls.length > 0) {
      enqueueSnackbar(
        `Please add a valid URL with https:// for: ${invalidUrls.join(", ")}`,
        { variant: "error" }
      );
      setIsUpdating(false);
      return;
    }
    if (userInfo.type === 2) {
      if (!inputs.about) {
        enqueueSnackbar("About Yourself is required.", { variant: "error" });
        return;
      }
      if (
        !inputs.image ||
        (typeof inputs.image === "string" && !inputs.image.trim())
      ) {
        enqueueSnackbar("Profile image is required.", { variant: "error" });
        return;
      }
    }

    setIsUpdating(true);

    setInputs((old) => ({ ...old, loading: true }));

    const formData = new FormData();

    if (userInfo?.type === 2) {
      formData.append("company_name", inputs.company_name);
      formData.append("contact_number", inputs.contact_number);
      formData.append("post_code", inputs.post_code);
      formData.append("status", true);
      formData.append("sector", inputs.sectorChoose);
      formData.append("linkedin", inputs.linkedIn_link);
      formData.append("youtube", inputs.youtube);
      formData.append("twitter", inputs.twitter_link);
      formData.append("instagram", inputs.instagram_link);
      formData.append("facebook", inputs.facebook_link);
      formData.append("contact_name", inputs.contact_name);
      formData.append("location", inputs.location);
      formData.append("website", inputs.website);
      formData.append("about", inputs.about);

      if (inputs.image && typeof inputs.image !== "string") {
        formData.append("image", inputs.image);
      } else if (!inputs.image && userInfo?.profile_image) {
        formData.append("image", userInfo?.profile_image);
      }
    } else {
      formData.append("first_name", inputs.first_name);
      formData.append("last_name", inputs.last_name);
      formData.append("contact_number", inputs.contact_number);
      formData.append("post_code", inputs.post_code);
      formData.append("status", true);
      formData.append("street", inputs.street_address);
      formData.append("state", inputs.state);
      formData.append("city", inputs.city);
      formData.append("country", inputs.country);

      if (inputs.image && typeof inputs.image !== "string") {
        formData.append("image", inputs.image);
      } else if (!inputs.image && userInfo?.profile_image) {
        formData.append("image", userInfo?.profile_image);
      }
    }
    console.log(...formData, "faskdoaijdoiadformdata");

    try {
      let response;
      if (userInfo?.type === 2) {
        response = await client_profile_edit_api(
          userInfo?.user_id?._id,
          formData
        );
      } else {
        response = await candidate_edit_profile_api(
          userInfo?.user_id?._id,
          formData
        );
      }

      if (response?.code === 200) {
        const data = { ...(response.data || response?.customer) };
        setInputs((old) => ({ ...old, ...data }));

        // Preserve is_temporary_password if it was already set to false
        const currentUser = JSON.parse(localStorage.getItem("user"));
        const updatedData = {
          ...data,
          is_temporary_password:
            currentUser.is_temporary_password === false
              ? false
              : data.is_temporary_password,
        };

        localStorage.setItem("user", JSON.stringify(updatedData));
        enqueueSnackbar(response.message, { variant: "success" });
        setUserInfo(updatedData);
      } else {
        enqueueSnackbar(response?.message || "Something went wrong", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("Network error. Please try again.", { variant: "error" });
    } finally {
      setIsUpdating(false);
    }
  };
  console.log(userInfo, "userInfouserInfouserInfouserInfo");
  useEffect(() => {
    if (userInfo) {
      setInputs((old) => ({
        ...old,
        ...userInfo,
        company_name: userInfo?.company_name,
        instagram_link: userInfo.social_links?.instagram,
        facebook_link: userInfo.social_links?.facebook,
        twitter_link: userInfo.social_links?.twitter,
        linkedIn_link: userInfo.social_links?.linkedin,
        youtube: userInfo.social_links?.youtube,
        sectorChoose: userInfo.sector,
        contact_name: userInfo.contact_name,
        street_address: userInfo?.street,
        post_code: userInfo?.post_code,
        about: userInfo?.about,
        image: userInfo?.profile_image,
      }));
      if (userInfo?.profile_image) {
        setCroppedImage(s3baseUri + userInfo.profile_image);
      }
      setPreviews(userInfo?.profile_image);
    }
  }, [userInfo]);
  console.log(inputs.image, "inputs.image value:");
  console.log(s3baseUri + inputs.image, "Full image URL:");
  console.log(croppedImage, "croppedImage value:");
  console.log(cropModalOpen, "cropModalOpen state:");
  console.log(userInfo?.type, "User type:");

  return (
    <>
      <div className="contaner-fluid">
        <GeneralMuiModal
          open={inputs.dialogOpen}
          setOpen={handleDialogClose}
          componentToPass={
            <>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  className="de-flex text-center justify-cotent-center"
                  alt="Profile"
                  src={
                    croppedImage ||
                    (inputs.image && typeof inputs.image === "string"
                      ? s3baseUri + inputs.image
                      : "")
                  }
                  style={{ width: 200, height: 200, margin: "0 auto" }}
                />
              </div>
            </>
          }
        />
        <div style={{ display: "flex", justifyContent: "center" }}></div>
      </div>
      {userInfo.type === 2 && (
        <div className="d-flex justify-content-center mt-4">
          <div className="card edit-profile-card p-1 text-center">
            <div className="d-flex edit-profle-image mt-3">
              <Avatar
                alt="Profile Picture"
                src={
                  croppedImage ||
                  (inputs.image && typeof inputs.image === "string"
                    ? s3baseUri + inputs.image
                    : "")
                }
                sx={{ width: 100, height: 100, mb: 2 }}
              />

              <IconButton
                color="primary"
                aria-controls="profile-menu"
                aria-haspopup="true"
                onClick={handleMenuOpen}
                sx={{
                  bgcolor: "white",
                  color: "navy",
                  borderRadius: "50%",
                  bottom: "50px",
                  left: "40px",
                  "&:hover": {
                    color: "navy",
                    backgroundColor: "white",
                  },
                }}
              >
                <CameraAltIcon />
              </IconButton>

              <Menu
                id="profile-menu"
                anchorEl={inputs.anchorEl}
                open={Boolean(inputs.anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <MenuItem onClick={handleUpdateImage}>
                  <ListItemIcon>
                    <CameraAltIcon fontSize="small" />
                  </ListItemIcon>
                  Update Image
                </MenuItem>
                <MenuItem onClick={handleViewProfile}>
                  <ListItemIcon>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon>
                  View Image
                </MenuItem>
              </Menu>
              <input
                hidden
                accept="image/jpeg, image/jpg, image/png, image/webp"
                type="file"
                ref={fileInputRef}
                onChange={fileChangedHandler}
              />

              {/* Crop Modal */}
              {cropModalOpen && (
                <CropPopUp
                  open={cropModalOpen}
                  onClose={() => setCropModalOpen(false)}
                  imageSrc={file}
                  crop={crop}
                  setCrop={setCrop}
                  onImageLoaded={onImageLoaded}
                  onCropComplete={onCropComplete}
                  onSave={handleCropImage}
                  onSaveFullImage={handleSaveFullImage}
                />
              )}
            </div>
            <form component="form" onSubmit={handleSubmit} sx={{ mt: 0 }}>
              <div className="container">
                <div className="" style={{ display: "flex", gap: "10px" }}>
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      margin="normal"
                      required
                      id="company_name"
                      label="Company Name"
                      name="company_name"
                      value={inputs.company_name}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px", // Decreased height
                          borderRadius: "6px", // Added border radius
                        },
                      }}
                    />
                  </div>
                  {userInfo?.client_type?.includes("clients") ? (
                    <div style={{ flex: 1, marginTop: "10px" }}>
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label">
                          Choose Sector
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="sectorChoose"
                          value={inputs.sectorChoose}
                          label="Choose Sector"
                          onChange={handleChange}
                          sx={{
                            height: "50px",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            marginTop: "4px",
                            "& .MuiSelect-select": {
                              display: "flex",
                              alignItems: "center",
                              height: "90%",
                              padding: "0 10px",
                            },
                          }}
                        >
                          <MenuItem value={"Hotel"}>Hotel</MenuItem>
                          <MenuItem value={"Pub"}>Pub</MenuItem>
                          <MenuItem value={"Restaurant"}>Restaurant</MenuItem>
                          <MenuItem value={"Cafe"}>Cafe</MenuItem>
                          <MenuItem value={"Contract Catering"}>
                            Contract Catering
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  ) : (
                    <div style={{ flex: 1 }}>
                      <TextField
                        required
                        fullWidth
                        margin="normal"
                        id="contact_name"
                        label="Contact Name"
                        name="contact_name"
                        type="text"
                        value={inputs.contact_name}
                        onChange={handleChange}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "50px", // Decreased height
                            borderRadius: "6px", // Added border radius
                          },
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="" style={{ display: "flex", gap: "10px" }}>
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      margin="normal"
                      required
                      id="post_code"
                      label="Postal Code"
                      name="post_code"
                      type="number"
                      value={inputs.post_code}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px", // Decreased height
                          borderRadius: "6px", // Added border radius
                        },
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      required
                      margin="normal"
                      id="contact_number"
                      label="Contact Number"
                      name="contact_number"
                      type="number"
                      value={inputs.contact_number}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px", // Decreased height
                          borderRadius: "6px", // Added border radius
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ display: "flex", gap: "10px" }}>
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      margin="normal"
                      required
                      id="Location"
                      label="Location"
                      name="location"
                      type="text"
                      value={inputs.location}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px", // Decreased height
                          borderRadius: "6px", // Added border radius
                        },
                      }}
                    />
                  </div>
                  {userInfo?.client_type?.includes("clients") ? (
                    <div style={{ flex: 1 }}>
                      <TextField
                        required
                        fullWidth
                        margin="normal"
                        id="contact_name"
                        label="Contact Name"
                        name="contact_name"
                        type="text"
                        value={inputs.contact_name}
                        onChange={handleChange}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "50px",
                            borderRadius: "6px",
                          },
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ flex: 1 }}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="linkedIn_link"
                        label="LinkedIn Link"
                        name="linkedIn_link"
                        type="text"
                        value={inputs.linkedIn_link}
                        onChange={handleChange}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "50px", // Decreased height
                            borderRadius: "6px", // Added border radius
                          },
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="" style={{ display: "flex", gap: "10px" }}>
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      margin="normal"
                      id="website"
                      label="Website"
                      name="website"
                      type="text"
                      value={inputs.website}
                      required
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px", // Decreased height
                          borderRadius: "6px", // Added border radius
                        },
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <TextField
                      required
                      fullWidth
                      margin="normal"
                      id="youtube"
                      label="Youtube Link"
                      name="youtube"
                      type="text"
                      value={inputs.youtube}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px", // Decreased height
                          borderRadius: "6px", // Added border radius
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ display: "flex", gap: "10px" }}>
                  <div style={{ flex: 1 }}>
                    <TextField
                      required
                      fullWidth
                      margin="normal"
                      id="instagram_link"
                      label="Instagram Link"
                      name="instagram_link"
                      type="text"
                      value={inputs.instagram_link}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px", // Decreased height
                          borderRadius: "6px", // Added border radius
                        },
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <TextField
                      required
                      fullWidth
                      margin="normal"
                      id="facebook_link"
                      label="Facebook  Link"
                      name="facebook_link"
                      type="text"
                      value={inputs.facebook_link}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px", // Decreased height
                          borderRadius: "6px", // Added border radius
                        },
                      }}
                    />
                  </div>
                </div>

                <div className="" style={{ display: "flex", gap: "10px" }}>
                  <div style={{ flex: 1 }}>
                    <TextField
                      required
                      fullWidth
                      margin="normal"
                      id="twitter_link"
                      label="Twitter Link"
                      name="twitter_link"
                      type="text"
                      value={inputs.twitter_link}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                  {userInfo?.client_type?.includes("clients") ? (
                    <div style={{ flex: 1 }}>
                      <TextField
                        required
                        fullWidth
                        margin="normal"
                        id="linkedIn_link"
                        label="LinkedIn Link"
                        name="linkedIn_link"
                        type="text"
                        value={inputs.linkedIn_link}
                        onChange={handleChange}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "50px",
                            borderRadius: "6px",
                          },
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ flex: 1 }}></div>
                  )}
                </div>
                <h6 className="mt-1" style={{ textAlign: "left" }}>
                  About Yourself*
                </h6>
                <div style={{ flex: 1 }}>
                  <TextEditor
                    required
                    inputs={inputs}
                    setInputs={setInputs}
                    name="about"
                    type="about"
                  />{" "}
                  {/* <TextField
                    rows={4}
                    fullWidth
                    multiline
                    margin="normal"
                    id="about"
                    label="About Yourself"
                    name="about"
                    type="text"
                    value={inputs.about}
                    onChange={handleChange}
                  /> */}
                </div>

                {/* Show rendered HTML only if content exists */}
              </div>
              <CropPopUp
                handleModalClose={handleModalClose}
                cropModalOpen={cropModalOpen}
                handleCropImage={handleCropImage}
                handleSaveFullImage={handleSaveFullImage}
                onCropComplete={onCropComplete}
                onImageLoaded={onImageLoaded}
                setCrop={setCrop}
                file={file}
                crop={crop}
              />

              <div className="container d-flex justify-content-end mb-3 mt-2">
                <button className="theme-button-contained" type="submit">
                  {isUpdating ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {userInfo.type === 1 && (
        <div className="d-flex justify-content-center mt-4">
          <div className="card edit-profile-card p-1 text-center">
            <div className="d-flex edit-profle-image mt-3">
              <Avatar
                alt="Profile Picture"
                src={
                  croppedImage ||
                  (inputs.image && typeof inputs.image === "string"
                    ? s3baseUri + inputs.image
                    : "")
                }
                sx={{ width: 100, height: 100, mb: 2 }}
              />
              <IconButton
                color="primary"
                aria-controls="profile-menu"
                aria-haspopup="true"
                onClick={handleMenuOpen}
                sx={{
                  bgcolor: "white",
                  color: "navy",
                  borderRadius: "50%",
                  bottom: "50px",
                  left: "40px",
                  "&:hover": {
                    color: "navy",
                    backgroundColor: "white",
                  },
                }}
              >
                <CameraAltIcon />
              </IconButton>
              <Menu
                id="profile-menu"
                anchorEl={inputs.anchorEl}
                open={Boolean(inputs.anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                <MenuItem onClick={handleUpdateImage}>
                  <ListItemIcon>
                    <CameraAltIcon fontSize="small" />
                  </ListItemIcon>
                  Update Image
                </MenuItem>
                <MenuItem onClick={handleViewProfile}>
                  <ListItemIcon>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon>
                  View Image
                </MenuItem>
              </Menu>
              <input
                hidden
                accept="image/jpeg, image/jpg, image/png, image/webp"
                type="file"
                ref={fileInputRef}
                onChange={fileChangedHandler}
              />

              {/* Crop Modal for User Type 1 */}

              {cropModalOpen && (
                <CropPopUp
                  handleModalClose={handleModalClose}
                  cropModalOpen={cropModalOpen}
                  handleCropImage={handleCropImage}
                  handleSaveFullImage={handleSaveFullImage}
                  onCropComplete={onCropComplete}
                  onImageLoaded={onImageLoaded}
                  setCrop={setCrop}
                  file={file}
                  crop={crop}
                />
              )}
            </div>

            <form component="form" onSubmit={handleSubmit} className="p-3">
              <div className="container">
                <div style={{ display: "flex", gap: "10px" }}>
                  <TextField
                    fullWidth
                    margin="normal"
                    required
                    id="first_name"
                    label="First Name"
                    name="first_name"
                    value={inputs.first_name}
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "50px",
                        borderRadius: "6px",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    required
                    id="last_name"
                    label="Last Name"
                    name="last_name"
                    value={inputs.last_name}
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "50px",
                        borderRadius: "6px",
                      },
                    }}
                  />
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                  <TextField
                    fullWidth
                    margin="normal"
                    required
                    id="contact_number"
                    label="Contact Number"
                    name="contact_number"
                    type="number"
                    value={inputs.contact_number}
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "50px",
                        borderRadius: "6px",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    required
                    id="post_code"
                    label="Postal Code"
                    name="post_code"
                    value={inputs.post_code}
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "50px",
                        borderRadius: "6px",
                      },
                    }}
                  />
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                  <TextField
                    fullWidth
                    margin="normal"
                    id="country"
                    label="Country"
                    name="country"
                    value={inputs.country}
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "50px",
                        borderRadius: "6px",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    id="street_address"
                    label="Street Address"
                    name="street_address"
                    value={inputs.street_address}
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "50px",
                        borderRadius: "6px",
                      },
                    }}
                  />
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                  <TextField
                    fullWidth
                    margin="normal"
                    id="city"
                    label="City"
                    name="city"
                    value={inputs.city}
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "50px",
                        borderRadius: "6px",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    id="state"
                    label="State"
                    name="state"
                    value={inputs.state}
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "50px",
                        borderRadius: "6px",
                      },
                    }}
                  />
                </div>
                {/* 
                <TextField
                  fullWidth
                  margin="normal"
                  required
                  id="country"
                  label="Country"
                  name="country"
                  value={inputs.country}
                  onChange={handleChange}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "50px",
                      borderRadius: "6px",
                    },
                  }}
                /> */}
              </div>

              <div className="container d-flex justify-content-end mb-3 mt-2">
                <button className="theme-button-contained" type="submit">
                  {isUpdating ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default EditProfile;
